
import React from 'react';
import { User, LogOut, Moon, Sun } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useUser } from '@/contexts/UserContext';
import { useToast } from '@/hooks/use-toast';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const MobileMenuProfile = ({ onClose }: { onClose: () => void }) => {
  const { user } = useUser();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = React.useState(
    document.documentElement.classList.contains('dark')
  );

  const toggleTheme = () => {
    if (isDarkMode) {
      document.documentElement.classList.remove('dark');
      document.documentElement.classList.add('light');
      localStorage.setItem('theme', 'light');
      setIsDarkMode(false);
      // Update favicon
      const favicon = document.querySelector('link[rel="icon"]');
      if (favicon) {
        favicon.setAttribute('href', '/uploads/jspark-logo-light.png');
      }
    } else {
      document.documentElement.classList.remove('light');
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
      setIsDarkMode(true);
      // Update favicon
      const favicon = document.querySelector('link[rel="icon"]');
      if (favicon) {
        favicon.setAttribute('href', '/uploads/jspark-logo-dark.png');
      }
    }
    
    // Dispatch theme change event
    window.dispatchEvent(new CustomEvent('themechange', {
      detail: { isDark: !isDarkMode }
    }));
  };

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('username');
    toast({
      title: "Logged out",
      description: "You have been successfully logged out",
    });
    onClose();
    navigate('/login');
  };

  return (
    <div className="px-4 py-6 border-t border-border theme-transition">
      <div className="flex items-center mb-6">
        <div className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center overflow-hidden mr-3">
          <span className="text-sm font-medium text-secondary-foreground">{user.initials}</span>
        </div>
        <div>
          <p className="text-sm font-medium text-foreground">{user.name}</p>
          <p className="text-xs text-muted-foreground">{user.organization}</p>
        </div>
      </div>
      
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-sm text-foreground">Dark Mode</span>
          <Button variant="ghost" size="sm" onClick={toggleTheme} className="text-foreground">
            {isDarkMode ? <Sun className="h-4 w-4 text-amber-500" /> : <Moon className="h-4 w-4 text-blue-600" />}
          </Button>
        </div>
        
        <Link 
          to="/profile" 
          className="flex items-center space-x-2 text-sm text-foreground" 
          onClick={onClose}
        >
          <User className="h-4 w-4" />
          <span>Profile</span>
        </Link>
        
        <button 
          onClick={handleLogout}
          className="flex items-center space-x-2 text-sm text-red-500 w-full text-left"
        >
          <LogOut className="h-4 w-4" />
          <span>Log out</span>
        </button>
      </div>
    </div>
  );
};

export default MobileMenuProfile;
